import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Tour } from '../../../../../app/shared/models/tour.model';
import { Status } from '../../../../../app/shared/models/status.model';


@Component({
  selector: 'app-tour-list-modal',
  templateUrl: './tour-list-modal.component.html'
})
export class TourListModalComponent {

  @Input() tours: Tour[];
  @Input() status: Status;

  selection: Tour[] = [];

  constructor(
    public activeModal: NgbActiveModal
  ) { }
}
